/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The FormativeFamilies model module.
 * @module model/FormativeFamilies
 * @version v1
 */
class FormativeFamilies {
    /**
     * Constructs a new <code>FormativeFamilies</code>.
     * Familias formativas
     * @alias module:model/FormativeFamilies
     */
    constructor() { 
        
        FormativeFamilies.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>FormativeFamilies</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/FormativeFamilies} obj Optional instance to populate.
     * @return {module:model/FormativeFamilies} The populated <code>FormativeFamilies</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new FormativeFamilies();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('programs')) {
                obj['programs'] = ApiClient.convertToType(data['programs'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
FormativeFamilies.prototype['id'] = undefined;

/**
 * @member {String} name
 */
FormativeFamilies.prototype['name'] = undefined;

/**
 * @member {String} programs
 */
FormativeFamilies.prototype['programs'] = undefined;






export default FormativeFamilies;

